<script>
   
   export default {
      
      data() {
         return {
            
            states: [],           
            brands: [],
            models: [],
            rtos: [],
            fuel_types: [],
            hypothecations: [],
            gvws: [],

            contact_id: null,
            vehicle_id: null,

            vehicle: {},
            token: '',
            errors: {},

         };
      },

      props: {      
         base_route: {
            type: String,
            default: () => {
               return "contacts"
            },
         }
      },
      mounted() {
         this.contact_id = this.$route.params.contact_id;
         this.vehicle_id = this.$route.params.vehicle_id;
         this.fetchDetails();
         this.fetchDropDowns();        
      },

      methods: {   

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         alphaDotSpacesOnly(event) {
         let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32) || (keyCode == 46))  {
                  return;
            } else {
               event.preventDefault();
            }
         },

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },
         
         fetchDropDowns() {
            let url = "/api/hub/contacts/details?type=2";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  console.log(res);
                  var responseData = res.data.data;
                  this.brands = responseData.brands;
                  this.hypothecations = responseData.hypothecations;
                  this.fuel_types = responseData.fuel_types;
                  this.gvws = responseData.gvw;
                  this.states = responseData.states;

                  this.fetchModels();
                  this.fetchRTOs();
               })
               .catch((err) => console.log(err));
         },

         fetchModels() {
            let url = "/api/hub/contacts/getModels?type=2&brand_id=" + this.vehicle.brand_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.models = responseData.models;
               })
               .catch((err) => console.log(err));
         },

         fetchRTOs() {
            let url = "/api/hub/contacts/getRTO?type=2&state_id=" + this.vehicle.state_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.rtos = responseData.rto;
               })
               .catch((err) => console.log(err));
         },     

         fetchDetails() {
            let url = "api/hub/contacts/vehicles/details?id=" + this.vehicle_id;
            
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.vehicle = responseData.details;
               
               })
            .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },      

         updateVehicle() {
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            if(this.vehicle.vehicle_type == 2) {
               this.vehicle.carrier_type = '';
            }
            var data = JSON.stringify({

               "id": this.vehicle_id,
               "vehicle_number": this.vehicle.vehicle_number,
               "manufacturer": this.vehicle.manufacturer,
               "vehicle_type": this.vehicle.vehicle_type,
               "carrier_type": this.vehicle.carrier_type,
               "model_id": this.vehicle.model_id,
               "fuel_type_id": this.vehicle.fuel_type_id,
               "gvw_id": this.vehicle.gvw_id,
               "cubic_capacity": this.vehicle.cubic_capacity,
               "hypothecation_id": this.vehicle.hypothecation_id,
               "rto_id": this.vehicle.rto_id,
               "insurance_expiry": this.vehicle.insurance_expiry,
               "fitness_expiry": this.vehicle.fitness_expiry,
               "tax_expiry": this.vehicle.tax_expiry,
               "permit_expiry": this.vehicle.permit_expiry,
               "welfare_fund_renewal": this.vehicle.welfare_fund_renewal,
               "registration_renewal": this.vehicle.registration_renewal
            });
            this.loading = true;            
            this.errors = {};
            this.$axios
               .put("/api/hub/contacts/vehicles/update", data, config)
               .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }

                  this.$router.push({ name: this.base_route + ".vehicles", params:{id: this.contact_id} });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        // if(!this.vehicle.brand_id) {
                        //    this.errors['brand_id'] = [];
                        //    this.errors['brand_id'][0] = "Please select a brand";
                        // }
                        // if(!this.vehicle.state_id) {
                        //    this.errors['state_id'] = [];
                        //    this.errors['state_id'][0] = "Please select a state";
                        // }
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },          

      },
   }
</script>
    
<template>
   
   <b-card header-class="bg-transparent border-light" class="border border-light">
      <form class="form-horizontal" role="form" @submit.prevent="updateVehicle">
         <div class="row"> 

            <b-form-group class="col-lg-4 mb-3">
               <label>Vehicle No. <span class="text-danger">*</span></label>
               <b-form-input v-model="vehicle.vehicle_number" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_number) }"></b-form-input>
                              
               <div v-for="(val, index) in errors.vehicle_number" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3">
               <label>Manufacture Year</label>
               <b-form-input v-model="vehicle.manufacturer" maxlength="100" v-bind:class="{ 'is-invalid': Boolean(errors.manufacturer) }"></b-form-input>
                              
               <div v-for="(val, index) in errors.manufacturer" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>                           

            <b-form-group class="col-lg-4 mb-3">
               <label>Vehicle Type</label>
               <select class="form-control" v-model="vehicle.vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }" @change="vehicle.carrier_type=null">
                  <option :value="null" v-if="!vehicle.vehicle_type">Select Vehicle Type</option>
                  <option value="1">Taxi</option>
                  <option value="2">Private</option>
               </select>
                              
               <div v-for="(val, index) in errors.vehicle_type" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3" v-if="vehicle.vehicle_type==1">
               <label>Carrier Type</label>
               <select class="form-control" v-model="vehicle.carrier_type" v-bind:class="{ 'is-invalid': Boolean(errors.carrier_type) }">
                  <option :value="null">Select Carrier Type</option>
                  <option value="1">Passenger</option>
                  <option value="2">Carrier</option>
               </select>

                <div v-for="(val, index) in errors.carrier_type" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3">
               <label>Brand</label>
               <select class="form-control" v-model="vehicle.brand_id" @change="fetchModels(), vehicle.model_id=null" v-bind:class="{ 'is-invalid': Boolean(errors.brand_id) }">
                  <option :value="null" v-if="!vehicle.brand_id">Select Brand</option>
                  <option :value="brand.id" v-for="brand in brands" :key="brand.id">{{brand.brand}}</option>
               </select>

               <div v-for="(val, index) in errors.brand_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3" v-if="vehicle.brand_id">
               <label>Model</label>
               <select class="form-control" v-model="vehicle.model_id" v-bind:class="{ 'is-invalid': Boolean(errors.model_id) }">
                  <option :value="null" v-if="!vehicle.model_id">Select Model</option>
                  <option :value="model.id" v-for="model in models" :key="model.id">{{model.model}}</option>
               </select>

               <div v-for="(val, index) in errors.model_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3">
               <label>Fuel Type</label>
               <select class="form-control" v-model="vehicle.fuel_type_id" v-bind:class="{ 'is-invalid': Boolean(errors.fuel_type_id) }">
                  <option :value="null" v-if="!vehicle.fuel_type_id">Select Fuel Type</option>         
                  <option :value="fuel_type.id" v-for="fuel_type in fuel_types" :key="fuel_type.id">{{fuel_type.fuel_type}}</option>
               </select>

               <div v-for="(val, index) in errors.fuel_type_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3">
               <label>Cubic Capacity (CC)</label>
               <b-form-input v-model="vehicle.cubic_capacity" v-bind:class="{ 'is-invalid': Boolean(errors.cubic_capacity) }"></b-form-input>

               <div v-for="(val, index) in errors.cubic_capacity" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>  

            <b-form-group class="col-lg-4 mb-3">
               <label>Hypothecation</label>                              
               <select class="form-control" v-model="vehicle.hypothecation_id" v-bind:class="{ 'is-invalid': Boolean(errors.hypothecation_id) }">
                  <option :value="null">None</option>
                  <option :value="hypothecation.id" v-for="hypothecation in hypothecations" :key="hypothecation.id">{{hypothecation.hypothecation}}</option>
               </select>

               <div v-for="(val, index) in errors.hypothecation_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>  

            <b-form-group class="col-lg-4 mb-3">
               <label>State</label>
               <select class="form-control" v-model="vehicle.state_id" v-bind:class="{ 'is-invalid': Boolean(errors.state_id) }" @change="fetchRTOs(), vehicle.rto_id=null">
                  <option :value="null" v-if="!vehicle.state_id">Select State</option>
                  <option :value="state.id" v-for="state in states" :key="state.id">{{state.state}}</option>
               </select>

               <div v-for="(val, index) in errors.state_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>

            <b-form-group class="col-lg-4 mb-3" v-if="vehicle.state_id">
               <label>RTO</label>
               <select class="form-control" v-model="vehicle.rto_id" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }">
                  <option :value="null">Select RTO</option>
                  <option :value="rto.id" v-for="rto in rtos" :key="rto.id">{{rto.rto}}</option>
               </select>

               <div v-for="(val, index) in errors.rto_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>  

            <b-form-group class="col-lg-4 mb-3">
               <label>GVW</label>
               <select class="form-control" v-model="vehicle.gvw_id" v-bind:class="{ 'is-invalid': Boolean(errors.gvw_id) }">
                  <option :value="null" v-if="!vehicle.gvw_id">Select GVW</option>
                  <option :value="gvw.id" v-for="gvw in gvws" :key="gvw.id">{{gvw.gvw}}</option>
               </select>

               <div v-for="(val, index) in errors.gvw_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>  

            <b-form-group class="col-lg-4 mb-3">
               <label>Insurance Expiry Date</label>
               <b-form-input type="date" v-model="vehicle.insurance_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.insurance_expiry) }"></b-form-input>

               <div v-for="(val, index) in errors.insurance_expiry" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>   

            <b-form-group class="col-lg-4 mb-3">
               <label>Fitness Expiry Date</label>
               <b-form-input type="date" v-model="vehicle.fitness_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.fitness_expiry) }"></b-form-input>

               <div v-for="(val, index) in errors.fitness_expiry" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>   

            <b-form-group class="col-lg-4 mb-3">
               <label>Tax Expiry Date</label>
               <b-form-input type="date" v-model="vehicle.tax_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.tax_expiry) }"></b-form-input>

               <div v-for="(val, index) in errors.tax_expiry" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>    

            <b-form-group class="col-lg-4 mb-3">
               <label>Permit Expiry Date</label>
            <b-form-input type="date" v-model="vehicle.permit_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.permit_expiry) }"></b-form-input>

               <div v-for="(val, index) in errors.permit_expiry" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>      

            <b-form-group class="col-lg-4 mb-3">
               <label>Welfare Fund Renewal Date</label>
               <b-form-input type="date" v-model="vehicle.welfare_fund_renewal" v-bind:class="{ 'is-invalid': Boolean(errors.welfare_fund_renewal) }"></b-form-input>

               <div v-for="(val, index) in errors.welfare_fund_renewal" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>       

            <b-form-group class="col-lg-4 mb-3">
               <label>Registration Renewal Date</label>
               <b-form-input type="date" v-model="vehicle.registration_renewal" v-bind:class="{ 'is-invalid': Boolean(errors.registration_renewal) }"></b-form-input>

               <div v-for="(val, index) in errors.registration_renewal" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-form-group>                                           
                           
         </div>

         <div class="row mt-3">
            <div class="12">
               <button class="btn btn-primary me-2" type="submit">Update</button>
               <!-- <router-link :to="{ name: base_route + '.vehicles', params: { id: contact_id } }" class="btn btn-light">Cancel</router-link> -->
               <a href="#" @click.prevent="$router.go(-1)" class="btn btn-light">Cancel</a>
            </div>
         </div>
      </form>
   </b-card>               
</template>
